import { publicListings, listingById, saveListing } from './listingService';
export const getAllVacations = async (filters = {}) => {
  const result = await getVacations(0, filters);
  return Array.isArray(result) ? result : result?.items || [];
};
export const getAllVacationByCity = (city) => publicListings('Vacation/GetVacationByCity/' + encodeURIComponent(city));
export const getVacationById = (id) => listingById('Vacation', id);
export const createVacation = (data, files) => saveListing('Vacation', data, files);
export const createVacationOld = createVacation;
export const updateVacation = (data, files) => saveListing('Vacation', data, files, true);
export const getVacations = (page, filters = {}) => {
  const query = new URLSearchParams({ page: page || 0 });
  if (filters.sort) query.set('sort', filters.sort);
  if (filters.city) query.set('city', filters.city);
  if (filters.travelers) query.set('travelers', filters.travelers);
  // Stay dates are only meaningful together (server rejects one without the other).
  if (filters.checkIn && filters.checkOut) { query.set('checkIn', filters.checkIn); query.set('checkOut', filters.checkOut); }
  ['minPrice', 'maxPrice'].forEach(key => {
    const value = filters[key];
    if (value !== undefined && value !== null && String(value).trim() !== '') query.set(key, value);
  });
  return publicListings('Vacation/GetAllVacations?' + query);
};
export { saveFile } from './biensService';
export { addReservation as AddReservation, getMyReservation, getAllRequest, getAllReservation,
  getReservedDates, getCountReservationOnHold, acceptReservation, acceptReservation as updateReservation } from './reservationService';
